<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  props: {
    text: String,
    arrow: Boolean,
    hidden: Boolean,
    placement: {
      type: String,
      default: "top",
    },
    delay: String|Array
  },
  data: function () {
    return {
      hovered: false,
    };
  },
  methods: {},
};
</script>

<template>
  <div class="f-tippy">
    <slot v-if="(!text && !$slots.text) || hidden"> </slot>
    <Tippy v-if="(text || $slots.text) && !hidden" arrow="arrow" :placement="placement" :delay="delay" :hideOnClick="false">
      <template #trigger>
        <slot></slot>
      </template>
      <div v-if="text || $slots.text">
        <div v-html="text"></div>
        <slot name="text"></slot>
      </div>
    </Tippy>
  </div>
</template>

<style lang="scss">
</style>